// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2DwIN","resendInfoText":"OnGoingPaymentBox_resendInfoText__1YQ6a"};